/* ============================================================
   Nordstealth — Newsletter-Anmeldung: Shopify traegt ein,
   der eigene Endpunkt liefert den Code.

   Wertet jedes Formular mit [data-ns-nl] auf. Seit dem 01.09.2026
   ist die Reihenfolge UMGEDREHT (Bauplan 21, Abschnitt 5.2):

     1. Das native Shopify-Formular wird abgeschickt, in einen
        unsichtbaren Rahmen. Das ist der HAUPTWEG, nicht der
        Rueckfall.
     2. Danach holt der eigene Endpunkt den Rabattcode und schreibt
        den Einwilligungsnachweis an den Kunden.
     3. Der Code steht sofort im Fenster, die Seite laedt nicht neu.

   WARUM HERUM UND NICHT ANDERSHERUM

   Nur ein Formular im Onlineshop loest zwei Dinge aus, die kein
   anderer Weg ausloest: Shopifys Bestaetigungsmail (Double-Opt-in)
   und den Ausloeser "Customer subscribed to email marketing", an dem
   die Willkommensstrecke haengt. Ueber die Admin-API geht beides
   nachweislich nie (Shopify-Mitarbeiter Liam 14.07.2025, KyleG
   29.10.2025). Bis zum 01.09.2026 schrieb der eigene Endpunkt den
   Einwilligungsstand selbst. Das war bequem und es war der laufende
   Verstoss: kein Bestaetigungsklick, also kein Beleg dafuer, dass der
   Kunde wirklich wollte, und die Beweislast aus Paragraf 7 UWG liegt
   vollstaendig beim Shop.

   Der Endpunkt entscheidet ab jetzt NICHT mehr ueber die Anmeldung.
   Er gibt den Code zurueck und schreibt den Nachweis. Sonst nichts.

   HAUSSTIL, wie assets/ns-cart.js und assets/ns-sendung.js:
     ES5 (var, function, .then/.catch), IIFE, 'use strict',
     frueher Ausstieg wenn nichts zu tun ist, Ringpuffer
     window.__nsNewsletter fuer die Pruefwerkzeuge.

   FUENF DINGE, DIE NICHT VERHANDELBAR SIND

     1. Die Seite laedt NIE neu. Das native Absenden geht in den
        Rahmen ns_nl_rahmen, deshalb sieht der Kunde genau EINE
        Bestaetigung: das Fenster mit dem Code. Der Haendler hat am
        21.08.2026 zwei gesehen (Fenster mit Code, eine Sekunde
        spaeter Neuladen, oben anfangen, unten Shopifys "Danke fuer
        deine Anmeldung") und das zu Recht beanstandet.
     2. Das native Absenden laeuft ueber requestSubmit(), NIE ueber
        submit(). submit() loest das submit-Ereignis gar nicht aus,
        und genau dort haengt Shopifys hCaptcha: ohne Token antwortet
        /contact mit HTTP 400 und legt keinen Kunden an. Gemessen am
        21.08.2026, HANDBUCH Abschnitt 22.
     3. Je Adresse wird genau EINMAL nativ abgesendet. Sonst bekommt
        jemand, der nach einer Stoerung noch einmal drueckt, eine
        zweite Bestaetigungsmail.
     4. Die E-Mail geht nie in localStorage, nie in die Adresszeile,
        nie in den dataLayer. Gemerkt wird nur der Rabattcode, und
        der ist kein Personenbezug.
     5. Alles, was aus der Antwort kommt, wird ueber textContent
        gesetzt, nie ueber innerHTML. Kein technischer Fehler
        erreicht den Kunden: aus jeder Stoerung wird ein Satz in
        seiner Sprache.

   UND EINS, DAS IM MARKUP BEWUSST FEHLT

   Der Rahmen und das target-Merkmal am Formular stehen NICHT in
   sections/footer.liquid, sondern werden hier gesetzt. Ohne
   JavaScript soll die Anmeldung ein ganz gewoehnlicher Seitenwechsel
   mit Shopifys eigener Erfolgsmeldung bleiben (Bauplan 21, 5.2).
   Staende das target fest im Markup, ginge die Antwort auch dann in
   einen unsichtbaren Rahmen, und der Besucher saehe ueberhaupt
   nichts mehr.
   ============================================================ */
(function () {
  // Sprachschicht: auf einer deutschen Seite gibt es window.NSI18N nicht,
  // dann bleibt der zweite Parameter stehen. snippets/ns-i18n.liquid fuellt
  // NSI18N nur fuer andere Sprachen — der deutsche Weg aendert sich nicht.
  function T(s, d) { var w = window.NSI18N; return (w && typeof w[s] === 'string') ? w[s] : d; }
  'use strict';

  var SPEICHER = 'nsNlCode';
  var RINGPUFFER_MAX = 20;

  // Name des unsichtbaren Rahmens. Bewusst NICHT ns_hidden_iframe:
  // so heisst der Rahmen des Werbefensters (snippets/ns-popup.liquid),
  // und auf der Startseite stehen beide zugleich im Dokument. Zwei
  // Rahmen mit demselben Namen heisst, dass ein Formular im falschen
  // landet.
  var RAHMEN_NAME = 'ns_nl_rahmen';

  // Wie lange auf Shopifys Antwort im Rahmen gewartet wird, bevor der
  // Code geholt wird. Der Endpunkt sucht den Kunden, den Shopify
  // gerade erst angelegt hat; fragt er zu frueh, findet er ihn nicht
  // und der Einwilligungsnachweis fehlt. Wartet er zu lang, steht der
  // Kunde vor einem stillen Knopf. 2600 ms ist der Deckel, und er
  // greift nur, wenn der Rahmen gar nichts meldet.
  var NATIV_WARTE_MAX = 2600;

  // Merker, der den eigenen Riegel EINMAL durchlaesst. Ohne ihn faengt
  // der Zuhoerer unten das selbst ausgeloeste Absenden wieder ab.
  var DURCH = 'data-ns-nl-durch';

  var formulare = document.querySelectorAll('form[data-ns-nl]');
  if (!formulare.length) return;

  window.__nsNewsletter = window.__nsNewsletter || { ereignisse: [], fassung: 3 };
  window.__nsNewsletter.fassung = 3;

  function merken(was) {
    try {
      var p = window.__nsNewsletter.ereignisse;
      p.push(was);
      if (p.length > RINGPUFFER_MAX) p.shift();
    } catch (e) {
      /* ein Protokoll darf nie eine Anmeldung kippen */
    }
  }

  /* ------------------------------------------------------------
     Auf myshopify-Hosts muss _fd=0 an jede eigene Adresse, sonst
     leitet Shopify auf die Hauptdomain um. Bei einer Navigation
     ist das nur laestig, bei einem fetch blockt der Browser die
     Antwort als fremde Herkunft. Auf nordstealth.com aendert es
     nichts. Gleiche Regel wie in assets/ns-cart.js.
     ------------------------------------------------------------ */
  function eigeneAdresse(pfad) {
    if (location.hostname.indexOf('myshopify.com') === -1) return pfad;
    return pfad + (pfad.indexOf('?') === -1 ? '?' : '&') + '_fd=0';
  }

  function einloesenAdresse(code) {
    return eigeneAdresse('/discount/' + encodeURIComponent(code) + '?redirect=%2Fproducts%2Fbody-sling');
  }

  /* ============================================================
     Der unsichtbare Rahmen

     Er wird genau einmal gebaut, gleich beim Laden und nicht erst
     beim Absenden: ein frisch eingehaengter Rahmen meldet selbst ein
     load-Ereignis (about:blank), und das wuerde unten als "Shopify
     hat geantwortet" durchgehen. Wer ihn frueh baut, hat dieses eine
     Ereignis laengst hinter sich, wenn jemand tippt.

     NICHT GEMESSEN, gehoert aber in die Akte: Shopify antwortet auf
     /contact mit einer Weiterleitung, und die laedt eine ganze Seite
     IN den Rahmen. Deren Skripte laufen mit, und damit zaehlt eine
     Anmeldung moeglicherweise als zweiter Seitenaufruf im GTM. Das
     Werbefenster macht es seit jeher genauso, neu ist nur der
     Fussbereich. Ein sandbox-Merkmal am Rahmen wuerde die Skripte
     stilllegen, koennte aber auch Shopifys Captcha-Kette stoeren;
     das gehoert gemessen, bevor es jemand einbaut. Pruefweg:
     scripts/pruef-gtm.mjs.
     ============================================================ */
  var rahmen = null;

  function rahmenBauen() {
    if (rahmen) return rahmen;
    rahmen = document.getElementsByName(RAHMEN_NAME)[0] || null;
    if (rahmen) return rahmen;
    rahmen = document.createElement('iframe');
    rahmen.name = RAHMEN_NAME;
    rahmen.id = RAHMEN_NAME;
    rahmen.title = 'Formularziel';
    rahmen.setAttribute('aria-hidden', 'true');
    rahmen.setAttribute('tabindex', '-1');
    rahmen.style.display = 'none';
    document.body.appendChild(rahmen);
    return rahmen;
  }

  /* ------------------------------------------------------------
     Das native Absenden an Shopify.

     Es ist der Hauptweg, siehe Kopf. Die Antwort landet im Rahmen
     und interessiert niemanden; gewartet wird nur darauf, DASS sie
     da ist. Denn erst danach existiert der Kunde in Shopify, und
     erst dann kann der eigene Endpunkt seinen Nachweis an ihn
     schreiben.

     Wirft nie und lehnt nie ab. Klappt das Absenden nicht, laeuft
     der Kunde in die Stoerungsmeldung des naechsten Schritts, statt
     hier stehenzubleiben.
     ------------------------------------------------------------ */
  function nativAbsenden(form, adresse) {
    return new Promise(function (fertig) {
      var r = rahmenBauen();
      form.target = RAHMEN_NAME;

      // Der Riegel weiter unten laesst genau dieses eine Absenden
      // durch. Der Merker bleibt zwoelf Sekunden stehen, weil
      // hCaptcha das Formular nach seinem Token unter Umstaenden
      // selbst noch einmal abschickt.
      //
      // Der laufende Abraeumer wird ZUERST abgebrochen. Ohne das
      // schlaegt der Wecker des ersten Absendens mitten ins zweite:
      // wer sich um 0 s anmeldet und um 11,5 s noch einmal, verliert
      // den Merker um 12 s, also bevor hCaptcha sein Token hat und
      // das Formular selbst abschickt. Der Riegel sperrt dann genau
      // das Absenden, das durchgehen sollte. Der Besucher sieht
      // trotzdem die Bestaetigung, aber bei Shopify entsteht kein
      // Kunde. Gefunden beim Gegenlesen am 01.09.2026.
      if (form.nsDurchWecker) clearTimeout(form.nsDurchWecker);
      form.setAttribute(DURCH, '1');
      form.nsDurchWecker = setTimeout(function () {
        form.nsDurchWecker = 0;
        form.removeAttribute(DURCH);
      }, 12000);

      // Merker gegen die zweite Bestaetigungsmail: dieselbe Adresse
      // wird nie ein zweites Mal nativ abgesendet.
      form.setAttribute('data-ns-nl-nativ', String(adresse || '').toLowerCase());

      try {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          // Aeltere Browser ohne requestSubmit. NICHT form.submit():
          // das loest kein submit-Ereignis aus, hCaptcha bekaeme kein
          // Token und /contact antwortete mit 400. Ein kurzzeitiger
          // Absendeknopf loest es dagegen ganz regulaer aus.
          var hilfsknopf = document.createElement('button');
          hilfsknopf.type = 'submit';
          hilfsknopf.style.display = 'none';
          form.appendChild(hilfsknopf);
          hilfsknopf.click();
          form.removeChild(hilfsknopf);
        }
        merken({ was: 'nativ-ab' });
      } catch (e) {
        merken({ was: 'nativ-fehl', fehler: String(e).slice(0, 80) });
      }

      // Der Zuhoerer haengt sich ERST JETZT an, also nach dem
      // Absenden. Ein load-Ereignis, das vorher unterwegs war, kann
      // ihn damit nicht mehr treffen.
      var durch = false;
      function weiter() {
        if (durch) return;
        durch = true;
        if (r && r.removeEventListener) r.removeEventListener('load', weiter);
        fertig();
      }
      if (r && r.addEventListener) r.addEventListener('load', weiter);
      setTimeout(weiter, NATIV_WARTE_MAX);
    });
  }

  /* ============================================================
     Das Fenster mit dem Code

     Es wird genau einmal gebaut und haengt direkt am body: jeder
     Vorfahre mit overflow, transform oder filter wuerde es sonst
     beschneiden, und der Fussbereich hat beides.
     ============================================================ */
  var fenster = null;
  var zuletztFokussiert = null;

  function fensterBauen() {
    if (fenster) return fenster;

    var huelle = document.createElement('div');
    huelle.className = 'ns-nlp';
    huelle.setAttribute('role', 'dialog');
    huelle.setAttribute('aria-modal', 'true');
    huelle.setAttribute('aria-labelledby', 'ns-nlp-titel');
    huelle.hidden = true;

    var box = document.createElement('div');
    box.className = 'ns-nlp__box';

    var zu = document.createElement('button');
    zu.type = 'button';
    zu.className = 'ns-nlp__zu';
    zu.setAttribute('aria-label', T('ns.js.nl.fenster_zu', 'Fenster schließen'));
    zu.innerHTML = '&times;';

    var haken = document.createElement('div');
    haken.className = 'ns-nlp__haken';
    haken.setAttribute('aria-hidden', 'true');
    haken.innerHTML = '<svg viewBox="0 0 24 24"><path d="m4.5 12.5 5 5 10-11"/></svg>';

    var titel = document.createElement('h2');
    titel.className = 'ns-nlp__titel';
    titel.id = 'ns-nlp-titel';

    var text = document.createElement('p');
    text.className = 'ns-nlp__text';

    var code = document.createElement('div');
    code.className = 'ns-nlp__code';
    code.setAttribute('role', 'text');

    var gilt = document.createElement('p');
    gilt.className = 'ns-nlp__gilt';

    var kopieren = document.createElement('button');
    kopieren.type = 'button';
    kopieren.className = 'ns-nlp__knopf ns-nlp__knopf--zweit';
    kopieren.textContent = 'Code kopieren';

    var kopiert = document.createElement('p');
    kopiert.className = 'ns-nlp__kopiert';
    kopiert.setAttribute('role', 'status');
    kopiert.setAttribute('aria-live', 'polite');

    var einloesen = document.createElement('a');
    einloesen.className = 'ns-nlp__knopf ns-nlp__knopf--haupt';
    einloesen.href = '#';

    box.appendChild(zu);
    box.appendChild(haken);
    box.appendChild(titel);
    box.appendChild(text);
    box.appendChild(code);
    box.appendChild(gilt);
    box.appendChild(einloesen);
    box.appendChild(kopieren);
    box.appendChild(kopiert);
    huelle.appendChild(box);
    document.body.appendChild(huelle);

    zu.addEventListener('click', fensterZu);
    huelle.addEventListener('click', function (e) {
      if (e.target === huelle) fensterZu();
    });

    // Tastatur: Escape schliesst, Tab bleibt im Fenster. Ohne die
    // Falle wandert der Fokus hinter das Fenster und die Seite
    // scrollt fuer den Tastaturnutzer sichtbar weg.
    document.addEventListener('keydown', function (e) {
      if (!fenster || fenster.huelle.hidden) return;
      if (e.key === 'Escape') {
        fensterZu();
        return;
      }
      if (e.key !== 'Tab') return;
      var ziele = fenster.huelle.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
      if (!ziele.length) return;
      var erstes = ziele[0];
      var letztes = ziele[ziele.length - 1];
      if (e.shiftKey && document.activeElement === erstes) {
        e.preventDefault();
        letztes.focus();
      } else if (!e.shiftKey && document.activeElement === letztes) {
        e.preventDefault();
        erstes.focus();
      }
    });

    kopieren.addEventListener('click', function () {
      kopiereCode(fenster.code.textContent, kopiert);
    });

    fenster = {
      huelle: huelle,
      titel: titel,
      text: text,
      code: code,
      gilt: gilt,
      einloesen: einloesen,
      kopieren: kopieren,
      kopiert: kopiert,
    };
    return fenster;
  }

  function fensterAuf(daten) {
    var f = fensterBauen();
    zuletztFokussiert = document.activeElement;

    f.titel.textContent = T('ns.js.nl.code_da', 'Dein Code ist da');
    /* Bewusst NICHT mehr "Du bist eingetragen". Shopify hat die
       Anmeldung aufgenommen, ein Abonnement wird sie erst mit dem
       Klick in der Bestaetigungsmail. Der Satz sagt beides, und er
       sagt die Bestaetigungsmail ausdruecklich an: sie kommt gleich
       ins Postfach, und wer nicht mit ihr rechnet, klickt nicht.
       Genau daran haengen die 279 Anmeldungen, die zwischen dem
       27.02. und dem 20.08.2026 auf halbem Weg steckengeblieben
       sind. */
    f.text.textContent =
      T('ns.js.nl.bestaetigung_vor', 'Wir haben dir eine Bestätigungsmail geschickt. Dein Code für ') +
      daten.prozent +
      T('ns.js.nl.bestaetigung_nach', ' Prozent auf den Body-Sling gilt schon jetzt.');
    f.code.textContent = daten.code;
    f.code.setAttribute('aria-label', 'Rabattcode ' + daten.code.split('').join(' '));
    f.gilt.textContent = T('ns.js.nl.gilt', 'Gilt für den Body-Sling, einmal je Kunde, ohne Mindestbestellwert.');
    f.einloesen.textContent = T('ns.js.nl.code_knopf', 'Code sichern und ansehen');
    f.einloesen.href = einloesenAdresse(daten.code);
    f.kopiert.textContent = '';
    f.kopiert.classList.remove('ns-nlp--zeig');

    f.huelle.hidden = false;
    // Erst im naechsten Frame die Klasse setzen, sonst faellt der
    // Uebergang aus: das Element war im selben Frame noch hidden.
    requestAnimationFrame(function () {
      f.huelle.classList.add('ns-nlp--auf');
      // Das Sperren nimmt die senkrechte Bildlaufleiste weg, und der
      // Inhalt springt um deren Breite nach rechts. Gemessen am
      // 21.08.2026: 390 gegen 375 px. Deshalb wird die Luecke als
      // Innenabstand ersetzt. Auf Geraeten mit ueberlagerter Leiste
      // ist sie 0 und es passiert nichts.
      var luecke = window.innerWidth - document.documentElement.clientWidth;
      if (luecke > 0) document.body.style.paddingRight = luecke + 'px';
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      // Der Fokus erst einen Frame SPAETER. Im selben Frame steht auf
      // der Huelle noch visibility:hidden aus dem Grundzustand, und ein
      // unsichtbares Element nimmt keinen Fokus an: der Fokus blieb am
      // body haengen, und Tastaturnutzer standen vor einem Fenster, das
      // sie nicht bedienen konnten. Gemessen am 21.08.2026 bei 390px,
      // sporadisch, es ist ein Rennen und kein fester Fehler. Deshalb
      // zusaetzlich ein zweiter Anlauf nach dem Uebergang.
      requestAnimationFrame(function () {
        f.einloesen.focus({ preventScroll: true });
        setTimeout(function () {
          if (!f.huelle.contains(document.activeElement)) {
            f.einloesen.focus({ preventScroll: true });
          }
        }, 350);
      });
    });
    merken({ was: 'fenster-auf', code: daten.code });
  }

  function fensterZu() {
    if (!fenster) return;
    fenster.huelle.classList.remove('ns-nlp--auf');
    // Immer alle drei zuruecksetzen. Bliebe eines stehen, koennte die
    // Seite nicht mehr scrollen, der teuerste Fehler dieser Art steht
    // in HANDBUCH Abschnitt 0.
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    setTimeout(function () {
      if (fenster) fenster.huelle.hidden = true;
    }, 320);
    if (zuletztFokussiert && zuletztFokussiert.focus) {
      zuletztFokussiert.focus({ preventScroll: true });
    }
    merken({ was: 'fenster-zu' });
  }

  /* ------------------------------------------------------------
     Kopieren. Die Zwischenablage ist in unsicherem Kontext und in
     Safari ohne Geste gesperrt, deshalb der alte Weg als Netz.
     Klappt gar nichts, bleibt der Code sichtbar stehen, er ist ja
     ohnehin gross im Fenster.
     ------------------------------------------------------------ */
  function kopiereCode(code, ziel) {
    function fertig(text) {
      ziel.textContent = text;
      ziel.classList.add('ns-nlp--zeig');
      setTimeout(function () {
        ziel.classList.remove('ns-nlp--zeig');
      }, 2600);
    }
    function ersatz() {
      var feld = document.createElement('textarea');
      feld.value = code;
      feld.setAttribute('readonly', '');
      feld.style.position = 'fixed';
      feld.style.opacity = '0';
      document.body.appendChild(feld);
      feld.select();
      try {
        document.execCommand('copy');
        fertig('Kopiert.');
      } catch (e) {
        fertig(T('ns.js.nl.notieren', 'Bitte den Code von Hand notieren.'));
      }
      document.body.removeChild(feld);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(code)
        .then(function () {
          fertig('Kopiert.');
        })
        .catch(ersatz);
    } else {
      ersatz();
    }
  }

  /* ============================================================
     Das Formular
     ============================================================ */

  function meldung(form, text, gut) {
    var m = form.querySelector('[data-ns-nl-meldung]');
    if (!m) return;
    m.textContent = text || '';
    m.classList.toggle('ns-nl__meldung--gut', gut === true);
    m.hidden = !text;
  }

  // Nach der Anmeldung bleibt der Code im Fussbereich stehen. Ohne
  // das steht dort wieder ein leeres Feld, und der Naechste fragt
  // sich, ob es geklappt hat.
  function fertigZeigen(form, code) {
    var kasten = form.parentNode.querySelector('[data-ns-nl-fertig]');
    if (!kasten) return;
    var feld = kasten.querySelector('[data-ns-nl-fertig-code]');
    var link = kasten.querySelector('[data-ns-nl-fertig-link]');
    if (feld) feld.textContent = code;
    if (link) link.href = einloesenAdresse(code);
    kasten.hidden = false;
    form.hidden = true;
  }

  function codeMerken(code) {
    try {
      localStorage.setItem(SPEICHER, JSON.stringify({ code: code, zeit: Date.now() }));
    } catch (e) {
      /* Privatmodus: dann eben nur fuer diesen Besuch */
    }
  }

  function gemerkterCode() {
    try {
      var roh = localStorage.getItem(SPEICHER);
      if (!roh) return '';
      var d = JSON.parse(roh);
      // Nach 90 Tagen wieder das Formular zeigen: wer so lange
      // nicht gekauft hat, hat den Code laengst vergessen.
      if (!d || !d.code || Date.now() - (d.zeit || 0) > 7776000000) return '';
      return String(d.code).slice(0, 32);
    } catch (e) {
      return '';
    }
  }

  /* ------------------------------------------------------------
     Der Ruf beim eigenen Endpunkt.

     Er steht hier allein, weil zwei Stellen ihn brauchen: das
     Formular im Fussbereich und das Werbefenster
     (snippets/ns-popup.liquid). Er holt den Rabattcode und loest
     nebenbei den Einwilligungsnachweis am Kunden aus. Ueber die
     Anmeldung selbst entscheidet er seit dem 01.09.2026 NICHT mehr;
     die hat Shopify zu diesem Zeitpunkt schon aufgenommen.

     Wirft nie. Das Ergebnis ist immer eines von dreien:
       { ok: true,  code, prozent }
       { ok: false, grund: 'abgelehnt', fehler, status }
       { ok: false, grund: 'stoerung' }
     ------------------------------------------------------------ */
  function endpunktFinden() {
    var f = document.querySelector('form[data-ns-nl][data-ns-nl-endpunkt]');
    return f ? f.getAttribute('data-ns-nl-endpunkt') : '';
  }

  function anmelden(mail, quelle, endpunkt, falleWert) {
    var ziel = endpunkt || endpunktFinden();
    if (!ziel) return Promise.resolve({ ok: false, grund: 'stoerung' });

    return fetch(ziel, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        mail: String(mail || '').trim(),
        quelle: quelle || 'seite',
        // Welche Fassung des Einwilligungssatzes der Kunde gesehen hat.
        // Der Worker legt genau diesen Wortlaut als Nachweis ab.
        sprache: (document.documentElement.getAttribute('lang') || 'de').slice(0, 2),
        firma: falleWert || '',
      }),
    })
      .then(function (a) {
        return a
          .json()
          .catch(function () {
            return null;
          })
          .then(function (d) {
            if (d && d.ok && d.code) {
              merken({ was: 'erfolg', status: a.status, code: d.code });
              codeMerken(d.code);
              return { ok: true, code: d.code, prozent: d.prozent || 10 };
            }
            // 400 und 429 sind Aussagen ueber die Eingabe, keine
            // Stoerungen. Sie gehoeren an das Feld, nicht in den
            // Rueckfall.
            if (a.status === 400 || a.status === 429) {
              merken({ was: 'abgelehnt', status: a.status });
              // Der eigene Text geht VOR dem des Endpunkts (21.09.2026).
              // Der Worker antwortet deutsch; auf einer englischen Seite
              // stuende sonst mitten im Formular ein deutscher Satz. Der
              // Servertext bleibt der Rueckfall fuer alles, was das Theme
              // nicht kennt.
              var meldung =
                (d && d.grund === 'zu_viele')
                  ? T('ns.js.nl.zu_viele', 'Es sind heute schon mehrere Anmeldungen von hier gekommen. Bitte melde dich morgen wieder oder schreib uns.')
                  : (d && d.grund === 'eingabe')
                    ? T('ns.js.nl.mail_fehler', 'Bitte gib eine gültige E-Mail-Adresse ein.')
                    : (d && d.fehler) || T('ns.js.nl.mail_fehler', 'Bitte gib eine gültige E-Mail-Adresse ein.');
              return { ok: false, grund: 'abgelehnt', status: a.status, fehler: meldung };
            }
            merken({ was: 'stoerung', status: a.status });
            return { ok: false, grund: 'stoerung' };
          });
      })
      .catch(function (err) {
        merken({ was: 'stoerung', fehler: String(err).slice(0, 80) });
        return { ok: false, grund: 'stoerung' };
      });
  }

  function absenden(form) {
    var feld = form.querySelector('input[type="email"]');
    // Der Knopf ist nach dem Riegel unten kein "submit" mehr, deshalb
    // ueber den Namen suchen, den das Theme ihm gibt.
    var knopf = form.querySelector('button[name="commit"], button[type="submit"], button');
    var endpunkt = form.getAttribute('data-ns-nl-endpunkt') || '';
    var quelle = form.getAttribute('data-ns-nl-quelle') || 'seite';
    var falle = form.querySelector('[data-ns-nl-falle]');
    var falleWert = falle ? String(falle.value || '').trim() : '';
    var wert = feld ? String(feld.value || '').trim() : '';

    // Zweimal auf denselben Knopf, oder Klick und Eingabetaste
    // zugleich: es laeuft schon eine Anmeldung, also nichts tun.
    if (form.getAttribute('data-ns-nl-laeuft')) return;

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(wert)) {
      meldung(form, T('ns.js.nl.mail_fehler', 'Bitte gib eine gültige E-Mail-Adresse ein.'));
      if (feld) feld.focus();
      merken({ was: 'eingabe-falsch' });
      return;
    }

    meldung(form, '');
    form.setAttribute('data-ns-nl-laeuft', '1');
    var urText = knopf ? knopf.textContent : '';
    if (knopf) {
      knopf.disabled = true;
      knopf.classList.add('ns-nl__laeuft');
      knopf.textContent = 'Einen Moment…';
    }

    function zurueck() {
      form.removeAttribute('data-ns-nl-laeuft');
      if (!knopf) return;
      knopf.disabled = false;
      knopf.classList.remove('ns-nl__laeuft');
      knopf.textContent = urText;
    }

    /* Wann nativ abgesendet wird, und wann nicht.

       NICHT, wenn der Honigtopf ausgefuellt ist: das ist ein Bot, und
       der soll bei Shopify gar nicht erst ankommen. Der Endpunkt
       bekommt ihn trotzdem zu sehen und antwortet wie immer mit einem
       Erfolg, der nichts anlegt. Die Antwort verraet dem Bot also
       nicht, dass er aufgeflogen ist.

       NICHT, wenn dieselbe Adresse schon einmal durch ist. Nach einer
       Stoerung darf der Kunde noch einmal druecken, ohne dafuer eine
       zweite Bestaetigungsmail zu bekommen. */
    var schonDurch = form.getAttribute('data-ns-nl-nativ') === wert.toLowerCase();
    var vorlauf =
      falleWert || schonDurch ? Promise.resolve() : nativAbsenden(form, wert);

    var versuche = 0;

    function codeHolen() {
      anmelden(wert, quelle, endpunkt, falleWert).then(fertigMachen);
    }

    function fertigMachen(e) {
      if (e.ok) {
        fertigZeigen(form, e.code);
        fensterAuf(e);
        zurueck();
        return;
      }
      if (e.grund === 'abgelehnt') {
        zurueck();
        meldung(form, e.fehler);
        if (feld) feld.focus();
        return;
      }
      /* Stoerung heisst seit dem 01.09.2026 etwas anderes als vorher:
         die Anmeldung IST bei Shopify, nur der Code fehlt. Deshalb
         wird nichts mehr nativ nachgeschoben (das gaebe eine zweite
         Bestaetigungsmail), sondern genau einmal beim Endpunkt
         nachgefasst. Danach steht ein Satz am Feld, der beides sagt.
         Die Seite laedt dabei nach wie vor nicht neu. */
      versuche++;
      if (versuche < 2) {
        merken({ was: 'nochmal' });
        setTimeout(codeHolen, 900);
        return;
      }
      merken({ was: 'aufgegeben' });
      zurueck();
      meldung(
        form,
        T('ns.js.nl.kein_code', 'Deine Anmeldung ist angekommen, aber der Rabattcode lässt sich gerade nicht anzeigen. Bitte probier es gleich noch einmal oder schreib uns an kontakt@nordstealth.de.')
      );
    }

    vorlauf.then(codeHolen);
  }

  /* ------------------------------------------------------------
     Anhaengen
     ------------------------------------------------------------ */
  Array.prototype.forEach.call(formulare, function (form) {
    // Ohne Endpunkt wird nichts aufgewertet: dann laeuft die
    // Anmeldung ganz ueber Shopify, mit Seitenwechsel und ohne
    // Sofort-Code. Das ist der Ausschalter im Theme-Editor, und er
    // darf kein halbes Verhalten erzeugen.
    if (!form.getAttribute('data-ns-nl-endpunkt')) return;

    /* DER RIEGEL: es darf kein UNGEWOLLTES submit-Ereignis entstehen.

       Ein preventDefault() im eigenen Zuhoerer reicht NICHT.
       Shopifys hCaptcha fuer Storefront-Formulare haengt in der
       Capture-Phase weiter oben im Baum, sieht das Ereignis also
       VOR uns, holt asynchron sein Token und schickt das Formular
       danach selbst ab. Vor dem 01.09.2026 sah der Kunde deshalb:
       Fenster mit dem Code, eine Sekunde spaeter laedt die Seite neu.
       Genau das hat der Haendler am 21.08.2026 gemeldet.

       Deshalb zwei Sperren:
         1. Der Knopf wird von "submit" auf "button" umgestellt.
            Ohne Absendeknopf loest ein Klick kein submit aus, und
            niemand kann eines abfangen, das es nicht gibt.
         2. Fuer die Eingabetaste im Feld (implizites Absenden, das
            es auch ohne Knopf gibt) zusaetzlich ein Zuhoerer in der
            CAPTURE-Phase mit stopImmediatePropagation.

       WAS SICH AM 01.09.2026 GEAENDERT HAT: der Riegel sperrt nicht
       mehr alles. Das native Absenden ist jetzt der Hauptweg und wird
       von nativAbsenden() selbst ausgeloest; dafuer setzt es den
       Merker data-ns-nl-durch, und der Zuhoerer laesst dieses eine
       Ereignis durch. Nur so kommt hCaptcha ueberhaupt an sein
       Token, und nur mit Token legt /contact einen Kunden an.
       Gesperrt bleibt alles, was NICHT von hier kommt.

       Ohne JavaScript passiert nichts davon: dann bleibt der Knopf
       ein Absendeknopf, das Formular hat kein target, und Shopifys
       Weg funktioniert wie immer, mit Seitenwechsel und eigener
       Erfolgsmeldung. */
    var knopf = form.querySelector('button[type="submit"]');
    if (knopf) {
      knopf.type = 'button';
      knopf.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        absenden(form);
      });
    }

    form.addEventListener(
      'submit',
      function (e) {
        if (form.getAttribute(DURCH)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        absenden(form);
      },
      true
    );

    /* Die Eingabetaste im Feld.

       Sie braucht einen eigenen Zuhoerer, und zwar wegen einer
       Eigenheit, die man nur beim Messen findet: das implizite
       Absenden mit der Eingabetaste gibt es nur, wenn es entweder
       einen Absendeknopf gibt (den haben wir gerade abgeschafft)
       oder GENAU EIN Textfeld im Formular steht. Der Honigtopf ist
       ein zweites. Gemessen am 21.08.2026 auf nordstealth.com:
       Adresse eintippen, Eingabetaste, und es passierte gar nichts,
       kein Fenster, kein Ereignis, keine Anmeldung. */
    var eingabe = form.querySelector('input[type="email"]');
    if (eingabe) {
      eingabe.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.keyCode !== 13) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        absenden(form);
      });
    }

    // Der Rahmen steht ab jetzt bereit, damit sein erstes eigenes
    // load-Ereignis nicht mitten in eine Anmeldung faellt.
    rahmenBauen();

    // Beim naechsten Besuch steht der Code gleich wieder da.
    var alt = gemerkterCode();
    if (alt) fertigZeigen(form, alt);
  });

  /* Fuer das Werbe-Popup (snippets/ns-popup.liquid): es hat eine
     eigene Oberflaeche mit Bundle-Auswahl und sendet auch selbst
     nativ ab, holt sich den Code aber hier. Sein natives Absenden
     macht es bewusst mit einer eigenen Fassung: es haengt an einem
     anderen Rahmen (ns_hidden_iframe), und die Fassung hier wuerde
     sein Formular auf ns_nl_rahmen umhaengen.

     ACHTUNG, versteckte Kopplung: diese Datei laedt nur, wenn im
     Fussbereich ein Block vom Typ email_signup steht
     (sections/footer.liquid). Wird der im Theme-Editor entfernt,
     findet das Werbefenster hier nichts mehr; die Anmeldung geht
     dann trotzdem an Shopify, aber der Code bleibt der aus dem
     Liquid. Siehe Bauplan 21, Abschnitt B4. */
  window.__nsNewsletter.anmelden = anmelden;

  // Fuer die Pruefwerkzeuge: sie oeffnen das Fenster mit festen
  // Daten, ohne eine echte Anmeldung auszuloesen.
  window.__nsNewsletter.zeigen = function (code, prozent) {
    fensterAuf({ code: code || 'TESTCODE', prozent: prozent || 10 });
  };
  window.__nsNewsletter.schliessen = fensterZu;
  window.__nsNewsletter.vergessen = function () {
    try {
      localStorage.removeItem(SPEICHER);
    } catch (e) {}
  };
})();
